<template>
  <div class="costCenter">
    <div class="costCenter__row costCenter__row--header">
      <div class="costCenter__name">Centrum kosztowe</div>
      <div class="costCenter__limit">Limit ustalony</div>
      <div class="costCenter__limitUsed">Wykorzystany</div>
      <div class="costCenter__limitAvailable">Dostępny</div>
    </div>
    <div class="costCenter__table prettyScrollbar">
      <div v-for="costCenter in costCenters" :key="costCenter.id" class="costCenter__row">
        <div class="costCenter__name">
          {{ costCenter.name }}
        </div>
        <div class="costCenter__limit">
          {{ costCenter.limit ? $helper.formatPrice(costCenter.limit) : '0 zł' }}
        </div>
        <div class="costCenter__limitUsed">
          {{ costCenter.limitUsed ? $helper.formatPrice(costCenter.limitUsed) : '0 zł' }}
        </div>
        <div class="costCenter__limitAvailable">
          {{
            costCenter.limitAvailable
              ? $helper.formatPrice(costCenter.limitAvailable)
              : 'Bez limitu'
          }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import costCentersMixin from '~/mixins/costCenters';

export default {
  name: 'CartDropdownCostCenter',
  mixins: [costCentersMixin],
};
</script>
<style lang="scss">
.costCenter {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &__table {
    width: 100%;
    display: flex;
    flex-direction: column;
    max-height: 26rem;
    overflow: scroll;
  }

  &__row {
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: space-between;
    border-bottom: 1px solid $cLightGrey;
    padding: 2rem 1rem;
    width: 95%;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 500;

    &--header {
      color: black;
      font-size: 1.5rem;
      line-height: 2rem;
      font-weight: 700;
    }
  }

  &__name {
    flex: 0 0 35%;
    max-width: 35%;
    font-weight: 700;
  }

  &__limit {
    flex: 0 0 26%;
    max-width: 26%;
  }

  &__limitUsed {
    flex: 0 0 26%;
    max-width: 26%;
  }

  &__limitAvailable {
    flex: 0 0 13%;
    max-width: 13%;
  }
}
</style>
